import React from 'react'
import ForgotPassword from "../Components/ForgotPas"

const ForgotPass = () => {
  return<>
  <section className="product-details p-5">
    <div className="conntainer-xxl">
        <div className="row">
<ForgotPassword/>
        </div>
    </div>
  </section>
  </>
}

export default ForgotPass